import {Component, OnDestroy, OnInit} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {UserData} from "../../auth/user.data";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, catchError, Subscription} from "rxjs";

@Component({
    selector: "fhm-user-edit-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./user-edit-page.component.html",
    standalone: false
})
export class UserEditPageComponent implements OnInit, OnDestroy {

    role: any;

    options: any[] = [
        {label: "admin", value: "admin"},
        {label: "buildTeam", value: "buildTeam"},
        {label: "onboardTeam", value: "onboardTeam"},
        {label: "salesRep", value: "salesRep"},
        {label: "salesManager", value: "salesManager"}
    ];

    email: string;
    title: string = "";

    data: UserData;

    public formGroup: FormGroup;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private http: HttpClient,
        private auth: AuthApiService,
        private router: Router,
        private route: ActivatedRoute,
        private errorHandler: ErrorHandlerService,
        private spinnersService: FUISpinnersService,
        private formBuilder: FormBuilder) {

        this.formGroup = this.formBuilder.group({
            role: ["", Validators.required]
        });

        this.formGroup.get("role")["required$"] = new BehaviorSubject(true);

    }

    ngOnInit(): void {
        this.spinnersService.open();
        this.route.paramMap.subscribe(params => {
            this.email = params.get("id");
            this.title = this.email;
            this.spinnersService.open();

            this.http.get<UserData>("/fonzie/user?email=" + this.email, {headers: this.auth.getHttpHeaderOptions()})
                .pipe(catchError((error) => {
                    return this.errorHandler.handleError(error);
                }))
                .subscribe(data => {
                    this.spinnersService.close();
                    this.data = data;
                    this.options.forEach((option) => {
                        if (option.value === this.data.role) {
                            this.role = option;
                        }
                    });
                });

        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    done(): void {
        this.router.navigate(["/main/user-search"]);
    }

    save(): void {
        Object.keys((this.formGroup.controls)).forEach((key) => {
            this.formGroup.controls[key].markAsTouched();
            this.formGroup.controls[key].updateValueAndValidity();
        });
        if (this.formGroup.status === "VALID" && this.role) {
            this.data.role = this.role.value;
            this.spinnersService.open();

            this.http.put<void>("/fonzie/user", this.data, {headers: this.auth.getHttpHeaderOptions()})
                .pipe(catchError((error) => {
                    return this.errorHandler.handleError(error);
                }))
                .subscribe(() => {
                    this.spinnersService.close();
                    this.done();
                });
        }
    }

}
